import { getStore } from "../utils/global";

export function normalizeMongolianPhone(input) {
  // keep only digits
  let digits = String(input).replace(/\D/g, "");

  // if it starts with international '00', strip that first
  if (digits.startsWith("00")) digits = digits.replace(/^00/, "");

  // if it now starts with country code 976 and looks like it had a country code:
  // - remove 976 when after removing it the remaining length is 8 (local number)
  // - or when the original input contained a '+' (user explicitly used intl form)
  const hadPlus = String(input).trim().startsWith("+");
  if (digits.startsWith("976") && (digits.length > 8 || hadPlus)) {
    digits = digits.slice(3);
  }

  return digits;
}

export function number_millify(num) {
  const lang = getStore("lang");
  if (lang === "mn") {
    return mongolianNumberMillify(num);
  } else {
    return internationalNumberMillify(num);
  }
}

function mongolianNumberMillify(num) {
  if (num === null || num === undefined) return null;
  if (num < 1000) return num;
  const units = ["мянган", "сая", "тэрбум", "их наяд"];
  let unitIndex = -1;
  let reducedNum = num;
  while (reducedNum >= 1000 && unitIndex < units.length - 1) {
    reducedNum /= 1000;
    unitIndex++;
  }
  return `${reducedNum.toFixed(1)} ${units[unitIndex]}`;
}

function internationalNumberMillify(num) {
  if (num === null || num === undefined) return null;
  if (num < 1000) return num;
  const units = ["K", "M", "B", "T"];
  let unitIndex = -1;
  let reducedNum = num;
  while (reducedNum >= 1000 && unitIndex < units.length - 1) {
    reducedNum /= 1000;
    unitIndex++;
  }
  return `${reducedNum.toFixed(1)}${units[unitIndex]}`;
}
